import { useQuery, QueryHookOptions } from '@apollo/client';

import GET_BUDGETS_FOR_CLIENT from '../queries/GetBudgetsForClientQuery';
import { GetBudgetsForClientQuery } from '../queries/types/GetBudgetsForClientQuery';

type IOptions = QueryHookOptions<GetBudgetsForClientQuery>;

export const useGetBudgetsForClientQuery = (options: IOptions = {}) => useQuery<GetBudgetsForClientQuery>(GET_BUDGETS_FOR_CLIENT, options);
